import styled, { createGlobalStyle } from 'styled-components';

export interface IContainer {
  height?: number | string;
  width?: number | string;
  minWidth?: number | string;
  minHeight?: number | string;
  maxWidth?: number | string;
  maxHeight?: number | string;
  margin?: number | string;
  resize?: 'horizontal' | 'vertical' | 'both';
  positionResize?: 'left' | 'right';
}

const getSizePx = (size: number | string | undefined, defaultValue?: number | string) => {
  const serialize = (v: string | number) => (typeof v === 'number' ? `${v}px` : v);

  if (size === null || size === undefined) {
    return defaultValue ? serialize(defaultValue) : 'unset';
  }

  return serialize(size);
};

export const Container = styled.div<IContainer>`
  position: relative;
  width: 100%;
  margin: ${(props) => props.margin};

  grid-column: span 2;

  @media only screen and (max-width: 500px) {
    grid-column: unset;
  }
  direction: ${(props) => {
    if (props.positionResize === 'left') return 'rtl';
    return 'ltr';
  }};

  .leaflet-container {
    resize: ${(props) => props.resize};

    height: ${({ height }) => getSizePx(height)};
    width: 100%;

    min-height: ${({ minHeight, height }) => getSizePx(minHeight, height)};
    min-width: ${({ minWidth, height }) => getSizePx(minWidth, height)};

    ${({ maxWidth }) => (maxWidth ? `max-width: ${getSizePx(maxWidth)}` : '')};
    ${({ maxHeight }) => (maxHeight ? `max-height: ${getSizePx(maxHeight)}` : '')};
  }

  .leaflet-control-attribution.leaflet-control {
    display: none !important;
  }

  .pulse_icon_personalized {
    display: block;
    border-radius: 50%;
    cursor: pointer;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% {
      -moz-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.4);
      box-shadow: 0 0 0 0;
    }
    70% {
      -moz-box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
      box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }
    100% {
      -moz-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
  }
`;

export const GlobalMapStyle = createGlobalStyle`
  .leaflet-control-zoom a {
    background-color: white;
    border: 0;
  }

  .leaflet-control-zoom a:hover{
    background-color: rgba(0, 0, 0, 0.1);
    border: 0;
  }

  .leaflet-control-zoom.leaflet-bar.leaflet-control {
    border: 0;
    background-color: white;
    padding: 5px;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  }

  .leaflet-draw-toolbar.leaflet-bar {
    border: 0;
    background-color: white;
    padding: 5px;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  }

  .leaflet-draw-toolbar.leaflet-bar a {
    border: 0;
  }
`;
